import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import InputField from "../../components/UI/Inputs/InputField";
import Button from "../../components/UI/Button";
import { useTranslation } from "../../hooks/useTranslation";
import style from "./index.module.css";
import { submitContactMessage } from "./utils";
import { Email, Whatsapp } from "../../components/Icons";
import logo_ar from "../../assets/images/logo_ar.png";
import logo_en from "../../assets/images/logo_en.png";
import { useSelector } from "react-redux";
import { selectUser } from "../../store/userSlice";

const ContactUs = () => {
  const { siteLang } = useSelector(selectUser);
  const { locale } = useTranslation();
  const contactus_email = process.env.REACT_APP_CONTACTUS_EMAIL
  const contactus_whatsapp = process.env.REACT_APP_CONTACTUS_WHATSAPP

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      phone: "",
      email: "",
      subject: "",
      message: "",
    },
  });

  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState("");

  const onSubmit = useCallback(
    async (data) => {
      setSubmitting(true);
      setFeedback("");
      try {
        await submitContactMessage(data);
        // On success, update the feedback state
        setFeedback(locale("submit_success"));
        reset();
      } catch (error) {
        setFeedback(locale("submit_error"));
      } finally {
        setSubmitting(false);
      }
    },
    [locale, reset],
  );

  return (
    <div className="main_section">
      <div className="container-lg">
        <div className="section_content_padding">
          <div className="row">
            <div className="col-12 col-md-6">
              <div className={style.section_header}>
                <h1 className="main_section__title main_section__title--small">{locale("contact_us")}</h1>
                <p>{locale("contact_us_sub_title")}</p>
                {feedback && feedback !== locale("submit_success") && <div className={style.feedback}>{feedback}</div>}
              </div>
              <form onSubmit={handleSubmit(onSubmit)} className={style.main_form}>
                <InputField
                  label={locale("phone")}
                  placeholder={locale("phone")}
                  type="phone"
                  extraProps={register("phone", { required: true })}
                  error={errors?.phone ? locale("required_field") : ""}
                />

                <InputField
                  label={locale("email") + " (" + locale("optional") + ")"}
                  placeholder={locale("email")}
                  type="email"
                  extraProps={{
                    ...register("email"),
                  }}
                />

                <InputField
                  label={locale("subject")}
                  placeholder={locale("subject")}
                  type="text"
                  extraProps={{
                    ...register("subject", { required: true, maxLength: 255 }),
                  }}
                  error={errors.subject ? locale("required_field") : ""}
                />

                <InputField
                  label={locale("message")}
                  placeholder={locale("message")}
                  type="textarea"
                  extraProps={{
                    ...register("message", { required: true }),
                  }}
                  error={errors.message ? locale("required_field") : ""}
                />

                <div className={style.form_ctas}>
                  <Button disabled={submitting} isLoading={submitting} styleType="primary_black" buttonType="submit">
                    {feedback === locale("submit_success") ? locale("submit_success") : locale("submit")}
                  </Button>
                </div>
              </form>
            </div>

            <div className="col-12 col-md-6 mt-4 section_header">
              <img src={siteLang === "ar" ? logo_ar : logo_en} alt={locale("romotors")} />
              <p className="mt-5 text-center">
                <a href={`mailto:${contactus_email}`} target="_blank" rel="noopener noreferrer" className={style.link}>
                  <Email width="35" height="35" color="#000"></Email> {contactus_email}
                </a>
              </p>
              <p>
                {" "}
                <a href={`https://wa.me/2${contactus_whatsapp}`} target="_blank" rel="noopener noreferrer" className={style.link}>
                  <Whatsapp width="35" height="35" color="primary"></Whatsapp> {contactus_whatsapp}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
